import React, { useMemo, useState } from "react";
import { useHistory, useLocation } from "react-router-dom";

import { isValidPassword } from "../../../Utils";
import { ScreensEnum } from "../../Feedback/Feedback.controller";
import { useResetPassword } from "../services/forgotPassword.actions";

import { PasswordScreen, PasswordScreenI } from "./Password.screen";

interface LocationState {
  eventId: string;
  login: string;
  store: string;
  document: string;
}

export const PasswordController: React.FC = () => {
  const location = useLocation<LocationState>()?.state;

  const [securityText, toggleVisible] = useState({
    newPassword: true,
    confirmPassword: true,
  });
  const [password, setPassword] = useState({
    newPassword: "",
    confirmPassword: "",
  });

  const { resetPassword } = useResetPassword();

  const history = useHistory();

  const [localState, setLocalState] = useState({
    loading: false,
  });

  const toggleLoading = (value: boolean) => {
    setLocalState({ ...localState, loading: value });
  };

  const handleChangePassword = (
    e: string,
    type: "newPassword" | "confirmPassword"
  ) => {
    setPassword({ ...password, [type]: e });
  };

  const statusButton = useMemo(() => {
    if (
      password.newPassword === password.confirmPassword &&
      isValidPassword(password.newPassword)
    ) {
      return true;
    } else {
      return false;
    }
  }, [password.confirmPassword, password.newPassword]);

  const handleSubmit = async (): Promise<void> => {
    try {
      toggleLoading(true);

      await resetPassword({
        variables: {
          eventId: location?.eventId,
          password: password.newPassword,
          login: location?.login,
          store: location?.store,
          document: location?.document,
        },
      });

      toggleLoading(false);
      history.replace({
        pathname: "/feedback",
        state: { type: ScreensEnum.RESET_SUCCESS },
      });
    } catch (error: any) {
      console.log({ ...error });
      const responseError = error?.graphQLErrors?.[0]?.extensions?.response;
      const status = responseError?.status;

      toggleLoading(false);

      if (status === 404) {
        history.replace({
          pathname: "/feedback",
          state: { type: ScreensEnum.USER_NOT_FOUND },
        });
        return;
      }

      history.replace({
        pathname: "/feedback",
        state: { type: ScreensEnum.UNEXPECTED_PROBLEMA },
      });
    }
  };

  const handle: PasswordScreenI = {
    variables: {
      newPassword: password.newPassword,
      confirmPassword: password.confirmPassword,
      loading: localState.loading,
      enable: statusButton,
      visibleNewPassword: securityText.newPassword,
      visibleConfirmPassword: securityText.confirmPassword,
    },
    actions: {
      onSubmit: handleSubmit,
      onChangePassword: handleChangePassword,
      toggleVisibility: (type: "newPassword" | "confirmPassword") => {
        toggleVisible({ ...securityText, [type]: !securityText[type] });
      },
    },
  };
  return <PasswordScreen {...handle} />;
};
